import { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';
import { isPWAInstalled, showInstallPrompt } from '../utils/pwaUtils';
import './PWAInstallPrompt.css';

export default function PWAInstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Verificar si ya está instalada
    if (isPWAInstalled()) {
      setIsInstalled(true);
      return;
    }

    // Escuchar el evento beforeinstallprompt
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Verificar si ya se mostró antes (usando localStorage)
    const hasShownBefore = localStorage.getItem('pwa-prompt-shown');
    if (hasShownBefore) {
      setShowPrompt(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      return;
    }

    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        console.log('[PWA] Usuario aceptó instalar la app');
      } else {
        console.log('[PWA] Usuario rechazó instalar la app');
      }
      
      setDeferredPrompt(null);
      setShowPrompt(false);
      localStorage.setItem('pwa-prompt-shown', 'true');
    } catch (error) {
      console.error('[PWA] Error al mostrar prompt:', error);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-shown', 'true');
  };

  // No mostrar si ya está instalada o si no hay prompt disponible
  if (isInstalled || !showPrompt || !deferredPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-install-content">
        <div className="pwa-install-icon">
          <Download size={24} />
        </div>
        <div className="pwa-install-text">
          <h3>Instalar Seekers Stock App</h3>
          <p>Instala la app para acceso rápido y funcionamiento offline</p>
        </div>
        <div className="pwa-install-actions">
          <button
            className="btn btn-primary btn-sm"
            onClick={handleInstall}
          >
            Instalar
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={handleDismiss}
            aria-label="Cerrar"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}

